{
	"default": {
		"logout": "Cerrar sesión navbar",
		"changeLanguage": "Cambiar idioma",
		"changeSystemLanguage": "Cambiar el idioma del sistema",
		"changeLayout": "Alterar layout"
	},
	"selectLanguageModal": {
		"selectLanguage": "Seleccione el idioma",
		"cancel": "Cancelar",
		"confirm": "Confirmar"
	},
	"event": {
		"barReports": "Informes de Bar",
		"salesReport": "Informes de ventas",
		"bookings": "Reservas",
		"clientArea": "Hub de Datos",
		"clients": "Información del cliente",
		"conference": "Conferencia de Evento",
		"financialReport": "Informes financieros",
		"guestList": "Listas de invitados",
		"multivendor": "Multi-vendor",
		"panel": "Panel",
		"businessIntelligence": "Panel general",
		"eventPanel": "Panel de eventos",
		"reports": "Informes",
		"customers": "Clientes",
		"devices": "Dispositivos",
		"sellChip": "Ventas sin tarjeta",
		"ticketsReport": "Informes de tickets",
		"zigTag": "Zig Tag",
		"operationReport": "Informe de Operación",
		"hawkersReport": "Informe de ambulantes",
		"rechargeManagement": "Gestión del saldo",
		"tableReports": "Informes de mesas"
	},
	"org": {
		"panel": "Lugares",
		"employee": "Acceso al equipo",
		"crm": "CRM",
		"categories": "Categorías",
		"reports": "Informes",
		"recharge": "Recarga",
		"stock": "Stock",
		"giftback": "Giftback",
		"giftCard": "Gift Card",
		"fiscal": "Fiscal",
		"taxRegistration": "Registro Fiscal",
		"internalSalesCampaign": "Campaña de ventas interna.",
		"productRegistration": "Registro de base de producto",
		"clientArea": "Hub de Datos",
		"customersList": "Lista de Clientes",
		"stockInventory": "Registro de base de producto",
		"taxData": "Datos fiscales",
		"fiscalSettings": "Datos fiscales",
		"financialReport": "Reportes",
		"satisfactionSurvey": "Encuesta de satisfacción",
		"customers": "Área de Clientes",
		"sendingMessages": "Enviar mensajes",
		"loyalty": "Programas de fidelización",
		"communication": "Campañas de Comunicación",
		"chartOfAccounts": "Plan de cuentas",
		"fiscalBoard": "Junta Fiscal",
		"vendors": "Proveedores",
		"team": "Equipo",
		"integrations": "Integraciones",
		"settings": "Configuración",
		"messagesAnalytics": "Analytics de Mensajes"
	},
	"place": {
		"audits": "Auditorías",
		"barReports": "Informes de Bar",
		"salesReport": "Informes de ventas",
		"prechargeReports": "Precarga por hoja de cálculo",
		"businessInteligence": "Business Intelligence",
		"pdvTeam": "Operadores de PDV",
		"productAndMenu": "Productos y Menús",
		"clientArea": "Hub de Datos",
		"cashFlow": "Financiero",
		"clients": "Clientes",
		"contracts": "Contratos",
		"placeData": "Información de contrato",
		"tagGroups": "Grupos de Etiquetas",
		"reserve": "Lista de espera",
		"reserveV2": "Gestión de reservas",
		"delivery": "Delivery",
		"deliveryOrders": "Pedidos",
		"deliveryReport": "Informes",
		"deliveryMenus": "Menús",
		"deliveryOrdersManager": "Gestor de pedidos",
		"deliverySettings": "Configuración",
		"events": "Eventos",
		"extract": "Extracto",
		"financialReport": "Informes financieros",
		"guestList": "Lista de invitados",
		"invoices": "Facturas",
		"transferReport": "Informe de transferencia",
		"multivendor": "Multi-vendor",
		"passwordCard": "Tarjeta de contraseña",
		"pos": "Ventas POS",
		"precharge": "Sitios de precarga",
		"products": "Productos",
		"menu": "Menú",
		"bars": "Bares y Sectores",
		"opened": "Abierto",
		"closed": "Cerrado",
		"crm": "CRM",
		"reports": "Informes",
		"preChargeLabel": "Pre-carga",
		"inventoryControl": "Control de inventario",
		"receptive": "Receptivo",
		"promotions": "Bonos, Promociones y Descuentos",
		"settings": "Configuración",
		"storage": "Almacenamiento",
		"storageReports": "Informes de Stock",
		"tickets": "Tickets",
		"ticketsReport": "Informes de tickets",
		"whatsup": "What's Up?",
		"zigAccount": "Cuenta Zig",
		"rechargeManagement": "Gestión del saldo",
		"financialFile": "Archivo financiero",
		"tableReports": "Informes de mesas",
		"generalConfig": "Configuración General",
		"operationReport": "Informe de operación",
		"config": "Configuraciones",
		"kds": "Gestor de pedidos (KDS)",
		"tableMap": "Mapa de mesas",
		"tableMapAttendanceManagement": "Gestión de atención",
		"kdsConfig": "Administrar KDS",
		"kdsReport": "Reporte de producción",
		"hawkersReport": "Informe de ambulantes"
	}
}
